/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Composes portals, modals, and toast overlays for ViewAppointments.
 * @module pages/viewAppointments/ViewAppointmentsOverlays
 */

import ViewAppointmentsDropdownPortals from "./ViewAppointmentsDropdownPortals.jsx";
import ViewAppointmentsModalsAndToasts from "./ViewAppointmentsModalsAndToasts.jsx";

const ViewAppointmentsOverlays = (props) => (
  <>
    <ViewAppointmentsDropdownPortals
      t={props.t}
      activeDropdownId={props.activeDropdownId}
      dropdownDirection={props.dropdownDirection}
      dropdownPosition={props.dropdownPosition}
      isFiltersDropdownOpen={props.isFiltersDropdownOpen}
      filtersDropdownDirection={props.filtersDropdownDirection}
      filtersDropdownPosition={props.filtersDropdownPosition}
      selectedStatusFilter={props.selectedStatusFilter}
      selectedRequirementsFilter={props.selectedRequirementsFilter}
      filterDropdownSelectStyles={props.filterDropdownSelectStyles}
      onActiveDropdownSeeProfile={props.onActiveDropdownSeeProfile}
      onActiveDropdownSeeRequest={props.onActiveDropdownSeeRequest}
      onActiveDropdownMakeVirtual={props.onActiveDropdownMakeVirtual}
      isActiveDropdownMakeVirtualDisabled={props.isActiveDropdownMakeVirtualDisabled}
      onClearFilters={props.onClearFilters}
      onStatusFilterChange={props.onStatusFilterChange}
      onRequirementsFilterChange={props.onRequirementsFilterChange}
    />
    <ViewAppointmentsModalsAndToasts
      t={props.t}
      isLoading={props.isLoading}
      showSuccessMessage={props.showSuccessMessage}
      isSlidingUp={props.isSlidingUp}
      showRescheduleSuccessMessage={props.showRescheduleSuccessMessage}
      isRescheduleSlidingUp={props.isRescheduleSlidingUp}
      showConfirmModal={props.showConfirmModal}
      showVirtualMeetingModal={props.showVirtualMeetingModal}
      showVirtualAppointmentErrorModal={props.showVirtualAppointmentErrorModal}
      selectedAppointmentForVirtual={props.selectedAppointmentForVirtual}
      isConvertingToVirtual={props.isConvertingToVirtual}
      virtualAppointmentError={props.virtualAppointmentError}
      eventData={props.eventData}
      confirmationDialogRef={props.confirmationDialogRef}
      virtualAppointmentDialogRef={props.virtualAppointmentDialogRef}
      virtualAppointmentErrorDialogRef={props.virtualAppointmentErrorDialogRef}
      onConfirmModalClose={props.onConfirmModalClose}
      onConfirmModalConfirm={props.onConfirmModalConfirm}
      onVirtualAppointmentClose={props.onVirtualAppointmentClose}
      onVirtualAppointmentConfirm={props.onVirtualAppointmentConfirm}
      onVirtualAppointmentErrorClose={props.onVirtualAppointmentErrorClose}
    />
  </>
);

export default ViewAppointmentsOverlays;
